import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { PageName, RsRoute } from '@Pages/RetroSynthesis/routes';
import Button from '@Components/Button';

import './RsProjectRouteRightHandLinks.scss';

function RsProjectRouteRightHandLinks({ projectId, routeId, onRouteViewClick }) {
  const history = useHistory();
  function navigationClickHandler(page) {
    onRouteViewClick(routeId);
    if (PageName.TREE_VIEW === page) {
      history.push(RsRoute.getProjectRouteTreeViewLink(projectId, routeId));
    }
  }
  const treeViewOnClickHandler = () => {
    navigationClickHandler(PageName.TREE_VIEW);
  };
  return (
    <div className="project-route-right-hand-links">
      <Button
        onClick={treeViewOnClickHandler}
        id={`project-route-right-hand-link-${routeId}`}
        buttonConfig={{
          className: 'project-route-right-hand-link',
          label: 'Tree view',
          type: 'primary',
          size: 'sm',
          e2eName: 'project-route-right-hand-link-tree-view',
        }}
        iconConfig={{
          position: 'after',
          name: 'chevron-right',
        }}
      />
    </div>
  );
}

RsProjectRouteRightHandLinks.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // Number ??
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onRouteViewClick: PropTypes.func,
};

export default RsProjectRouteRightHandLinks;
